{
  "next": "Далі",
  "nextStep": "Далі: {step}",
  "back": "Назад",
  "backToStart": "Назад на головну сторінку",
  "submit": "Надіслати",
  "submitContinue": "Далі",
  "submitNextStepNote": "Реєструє вашу заявку на членство. На наступному кроці ви оберете, як активувати автоплатіж.",
  "donationTypeMonthly": "Щомісяця",
  "donationTypeSingle": "Одноразово",
  "amountLabel": "Сума",
  "customAmount": "Інша сума",
  "minAmount": "Мінімальна сума — {min} {currency}",
  "perMonth": "{amount} kr/міс",
  "firstName": "Ім'я",
  "lastName": "Прізвище",
  "email": "Електронна пошта",
  "mobile": "Мобільний номер",
  "ssn": "Номер соціального страхування",
  "ssnPlaceholder": "РРРРММДД-NNNN",
  "ssnHint": "Наприклад 19940906-2388, використовується, щоб зареєструвати ваш подарунок і спробувати отримати вашу поштову адресу.",
  "membershipSsnHint": "Наприклад 19940906-2388, використовується, щоб зареєструвати ваше членство і спробувати отримати вашу поштову адресу.",
  "ssnMissingHelp": "Немає шведського особистого номера або не хочете його вказувати? Зверніться до служби підтримки, і ми допоможемо:",
  "birthDate": "Дата народження",
  "birthDateHint": "Дата народження, yyyy-mm-dd",
  "ssnOrBirthdateHint": "Немає шведського особистого номера? Вкажіть дату народження.",
  "birthDatePlaceholder": "рррр-мм-дд",
  "selectCountry": "Виберіть країну",
  "street": "Вулиця",
  "postcode": "Поштовий індекс",
  "city": "Місто",
  "country": "Країна",
  "consentHeader": "Sign the direct-debit mandate",
  "consentSubtitle": "Sign with BankID or receive the mandate by post",
  "consentBankid": "Sign with BankID",
  "consentPostal": "Receive mandate by post",
  "bankidStarting": "Starting BankID …",
  "bankidPending": "Open the BankID app and sign",
  "bankidPendingIdentify": "Open the BankID app and identify yourself",
  "bankidComplete": "Signing complete",
  "bankidFailed": "Signing was cancelled",
  "bankidRetry": "Try again",
  "openBankid": "Open BankID",
  "errorGeneric": "Щось пішло не так. Спробуйте ще раз.",
  "formClosed": "Цей збір закрито.",
  "formTryAgain": "Сталася тимчасова помилка. Спробуйте ще раз за хвилину.",
  "errorModalTitle": "Ой, щось пішло не так!",
  "errorModalRetry": "Спробувати ще раз",
  "errorModalContact": "Зверніться до служби підтримки:",
  "alreadyMemberTitle": "Уже член організації",
  "required": "Це поле обов'язкове",
  "invalidEmail": "Адреса електронної пошти вказана невірно",
  "invalidClearing": "Кліринговий номер має складатися з 4 цифр",
  "invalidAccount": "Номер рахунку має містити 4–12 цифр",
  "invalidSsn": "Невірний номер соціального страхування",
  "invalidMobile": "Невірний номер мобільного телефону",
  "invalidPostcode": "Невірний поштовий індекс",
  "minorDisclaimer": "You must be at least 18 to become a monthly donor. You can instead ",
  "minorLinkYouth": "become an annual member.",
  "minorLinkChild": "join the Rädda Djuren club.",
  "giftTitle": "Який вітальний подарунок ви бажаєте?",
  "giftSubtitle": "Подарунок буде надіслано вам поштою",
  "skipGift": "Я не хочу подарунка",
  "enlargeGiftImage": "Показати більше зображення: {title}",
  "chooseThisGift": "Обрати подарунок",
  "bankidSignMessage": "Я схвалюю щомісячний внесок {amount} SEK на користь Djurens Rätt, що сплачується через автожиро (autogiro). Його можна скасувати будь-коли, звернувшись до Djurens Rätt.",
  "bankidSignMessageNoAmount": "Я схвалюю мандат автожиро (autogiro) для Djurens Rätt. Його можна скасувати будь-коли, звернувшись до Djurens Rätt.",
  "thankYouTitle": "Дякуємо за вашу підтримку!",
  "thankYouTitleCompany": "Дякуємо за вашу підтримку!",
  "lookupCta": "Отримати мої дані",
  "lookupPending": "Отримуємо …",
  "lookupNotFound": "Дані не знайдено — заповніть вручну",
  "consentLinkNotFound": "За цим посиланням не знайдено згоди для підписання. Переконайтеся, що ви скористалися повним посиланням із нашого повідомлення, або зв’яжіться з нами, і ми допоможемо.",
  "lookupConfirm": "Ми знайшли ваші дані:",
  "lookupManual": "Заповнити вручну",
  "lookupInstead": "Отримати мої дані",
  "enterManually": "Enter account number manually",
  "manualFallbackPrompt": "Бажаєте натомість",
  "manualFallbackLink": "ввести дані рахунку вручну",
  "accountFetchPrompt": "How would you like to provide your account?",
  "useAccountConfirm": "Use this account",
  "bank": "Bank",
  "bankSelect": "Оберіть банк",
  "bankOther": "Інший банк",
  "fetchAccounts": "Fetch account via your bank",
  "fetchingAccounts": "Fetching account …",
  "accountsFailed": "Could not fetch account",
  "clearing": "Clearing number",
  "account": "Account number",
  "changeAccountPrefix": "Не той рахунок? Ви можете",
  "changeAccountManual": "ввести його вручну",
  "changeAccountOr": "або",
  "changeAccountFetch": "отримати інший рахунок",
  "clearingHint": "Зазвичай 4 цифри. У Sparbankerna/Swedbank — 5 (NNNN-N), вводьте без дефіса.",
  "sparbankWarning": "Переконайтеся, що вибрали правильний варіант: Sparbanken Syd, Swedbank або Swedbank Sparbankerna. Якщо один варіант не працює, спробуйте інший.",
  "flowTitle": "Стати щомісячним донором",
  "progressLabel": "Перебіг",
  "stepOf": "Крок {step} з {total}",
  "stepAmount": "Сума",
  "stepGift": "Подарунок",
  "stepDetails": "Дані",
  "stepAddress": "Адреса",
  "stepConsent": "Згода",
  "stepPayment": "Оплата",
  "thankYouBody": "Тепер ви щомісячний донор. Разом ми змінюємо життя тварин на краще.",
  "thankYouBodyCompany": "Тепер ви щомісячний донор. Разом ми змінюємо життя тварин на краще.",
  "donate": "Зробити пожертву",
  "donationFlowTitle": "Зробити пожертву",
  "choosePayment": "Як ви бажаєте сплатити?",
  "choosePaymentCompany": "Як ви бажаєте сплатити?",
  "paySwish": "Swish",
  "paySwishDesc": "Сплатіть миттєво через Swish",
  "payCard": "Картка",
  "payCardDesc": "Сплатити карткою",
  "payPostal": "Рахунок",
  "payPostalDesc": "Отримати рахунок поштою",
  "redirecting": "Перенаправляємо вас до оплати …",
  "redirectingCompany": "Перенаправляємо вас до оплати …",
  "donationCancelled": "Платіж скасовано. Ви можете спробувати ще раз.",
  "donationThankYouTitle": "Дякуємо за вашу пожертву!",
  "donationThankYouTitleCompany": "Дякуємо за вашу пожертву!",
  "donationThankYouBody": "Ваша пожертва змінює життя тварин на краще.",
  "donationPostalBody": "Ваш рахунок буде надіслано поштою. Дякуємо за вашу пожертву!",
  "integrityText": "Щоб обробити ваше членство та інформувати вас про нашу роботу для тварин, ми зберігаємо надану вами інформацію. Ми обробляємо вашу інформацію відповідно до Загального регламенту захисту даних, гарантуючи, що ваші дані будуть захищені і не будуть розголошені в будь-який інший спосіб.",
  "integrityTextDonation": "Щоб опрацювати ваш внесок та інформувати вас про нашу роботу для тварин, ми зберігаємо надані вами дані. Це відбувається відповідно до регламенту захисту даних: ми гарантуємо, що ваші дані захищені й не передаються нікому іншому.",
  "integrityTextDonationCompany": "Щоб опрацювати ваш внесок та інформувати вас про нашу роботу для тварин, ми зберігаємо надані вами дані. Це відбувається відповідно до регламенту захисту даних: ми гарантуємо, що ваші дані захищені й не передаються нікому іншому.",
  "integrityTextPetition": "Щоб зареєструвати ваш підпис та інформувати вас про нашу роботу для тварин, ми зберігаємо надані вами дані. Ваше ім'я та коментар (за наявності) стають підписом, який ми передаємо в кампанії. Ми обробляємо дані відповідно до регламенту захисту даних, що гарантує їх захист і нерозголошення жодним іншим способом.",
  "integrityTextActivist": "Щоб зареєструвати вас як цифрового волонтера та інформувати вас про нашу роботу для тварин, ми зберігаємо надані вами дані. Ми робимо це відповідно до регламенту захисту даних, що гарантує захист ваших даних і їх нерозголошення нікому іншому.",
  "integrityMore": "Дізнайтеся більше в нашій політиці конфіденційності",
  "integrityMoreLink": "політиці конфіденційності",
  "integrityUrl": "https://project1882.org/integrity",
  "annualFlowTitle": "Стати річним членом",
  "stepCategory": "Членство",
  "chooseCategory": "Яке членство ви бажаєте?",
  "categoryOrdinary": "Звичайний членський внесок: 330 крон",
  "categoryOrdinaryDesc": "Найбільша підтримка для тварин❤️ Долучайтеся і зробіть більше для них.",
  "categoryReduced": "Знижений членський внесок: 150 крон",
  "categoryReducedDesc": "Для тих, кому 18-25 років, для пенсіонерів і тих, хто отримує допомогу через хворобу.",
  "categoryYouth": "Безкоштовне членство: 0 крон",
  "categoryYouthDesc": "Для тих, кому 14-17 років і хто хоче долучитися заради тварин.",
  "membershipTabDjurensRatt": "Djurens Rätt",
  "membershipTabChild": "Для дітей",
  "membershipDjurensRattTitle": "Членство в Djurens Rätt",
  "membershipDjurensRattSubtitle": "Включає 4 журнали для членів на рік. Членство поновлюється щороку.",
  "membershipChildTitle": "Членство в Rädda Djuren-klubben",
  "membershipChildSubtitle": "Річне членство в Rädda Djuren-klubben — ідеальний подарунок дитині, якій небайдужі тварини. Воно включає 5 журналів на рік і гарний подарунок, який ви можете вручити новому членові.",
  "membershipChildNote": "Натисніть кнопку нижче, щоб перейти на сайт Rädda Djuren-klubben.",
  "youthBirthdateHint": "Вкажіть особистий номер або дату народження, щоб ми могли підтвердити, що вам 14–17 років.",
  "youthAgeError": "Молодіжне членство — для віку 14–17 років. Будь ласка, оберіть інший тип членства.",
  "youthFreeNote": "Молодіжне членство безкоштовне – вам не потрібно нічого сплачувати.",
  "becomeMember": "Стати членом",
  "annualThankYouTitle": "Вітаємо як члена!",
  "annualThankYouBody": "Дякуємо, що стали річним членом. Разом ми змінюємо життя тварин на краще.",
  "annualPostalBody": "Ваш рахунок буде надіслано поштою. Вітаємо як члена!",
  "annualYouthBody": "Ваше молодіжне членство зареєстровано. Вітаємо!",
  "alreadyMember": "Ви вже є членом. Зверніться до служби підтримки донорів, якщо у вас є запитання щодо членства.",
  "notYouFillIn": "Не ви? Заповніть власні дані",
  "giftedFlowTitle": "Подаруйте пожертву",
  "stepGiftImage": "Мотив",
  "stepGiftDetails": "Привітання",
  "stepDelivery": "Доставка",
  "giftcertTitle": "Ім'я отримувача",
  "giftcertChooseTitle": "Яку листівку ви хочете надіслати?",
  "giftcertChooseSubtitle": "Оберіть мотив",
  "giftcertTitlePlaceholder": "Кому призначений подарунок?",
  "giftcertMessage": "Ваше привітання",
  "giftcertMessageHint": "Напишіть особисте привітання, яке буде надруковано на подарунковому сертифікаті. Не забудьте вказати, від кого подарунок. Емодзі не можна використовувати.",
  "giftcertCharsLeft": "Залишилось {count} символів",
  "giftcertMessageNoEmoji": "Привітання не може містити емодзі.",
  "giftcertMessageTooLong": "Привітання може містити щонайбільше {max} символів.",
  "memorialHonoreeName": "Ім'я особи, яку ви вшановуєте",
  "memorialHonoreeNameError": "Будь ласка, введіть ім'я особи, яку ви вшановуєте",
  "deliveryTitle": "Як ви хочете доставити сертифікат?",
  "deliveryDigital": "Цифровий",
  "deliveryPrinted": "Друкований",
  "deliveryDigitalText": "Сертифікат надсилається у форматі PDF на вашу електронну пошту одразу після оплати.",
  "deliveryEmail": "Ваша електронна адреса",
  "deliveryPrintedText": "Ми друкуємо та надсилаємо подарунковий сертифікат поштою.",
  "deliveryRecipientHeading": "Хто має отримати сертифікат?",
  "deliveryMailToMe": "Надіслати сертифікат мені",
  "deliverySendWhen": "Коли надіслати картку?",
  "deliverySendNow": "Якнайшвидше",
  "deliverySendDate": "Обрати дату надсилання",
  "deliverySendDateLabel": "Дата доставки",
  "deliveryDateInvalid": "Оберіть дату, починаючи з сьогодні",
  "deliveryEstimate": "Орієнтовна доставка між {range}.",
  "deliveryToMeTitle": "Поштою до вас",
  "deliveryToMeText": "Подарунковий сертифікат надсилається поштою до вас і має надійти протягом п'яти робочих днів.",
  "deliveryToRecipientTitle": "Поштою до отримувача",
  "deliveryToRecipientText": "Подарунковий сертифікат надсилається поштою отримувачу і має надійти протягом п'яти робочих днів від обраної дати надсилання.",
  "deliveryOr": "або",
  "deliveryNote": "Зверніть увагу, що доставка триває до 3–5 робочих днів. На неї можуть впливати робота пошти та святкові дні.",
  "deliveryLastDateInfo": "Щоб гарантовано отримати доставку до {message}, замовте до {date}.",
  "deliveryAfterLastDate": "Ми більше не можемо гарантувати доставку до {message}.",
  "deliverySwitchDigital": "Оберіть цифрову доставку — сертифікат надійде на вашу пошту одразу після оплати.",
  "giftcertThankYouTitle": "Дякуємо за вашу пожертву!",
  "giftcertThankYouBody": "Ваш подарунковий сертифікат уже в дорозі. Дякуємо, що дарите пожертву тваринам.",
  "giftcertPostalBody": "Ваш рахунок буде надіслано поштою. Дякуємо за вашу пожертву!",
  "companyName": "Назва компанії",
  "organisationNumber": "Реєстраційний номер",
  "invoiceEmail": "Електронна пошта для рахунку",
  "stepCompany": "Компанія",
  "perMonthSuffix": "/міс",
  "payInvoice": "Рахунок",
  "payInvoiceDesc": "Отримати рахунок електронною поштою",
  "companyDonationFlowTitle": "Зробити пожертву від компанії",
  "recurringFlowTitle": "Стати щомісячним донором",
  "companyRecurringFlowTitle": "Стати щомісячним донором від компанії",
  "recurringThankYouTitle": "Дякуємо за вашу щомісячну підтримку!",
  "recurringThankYouTitleCompany": "Дякуємо за вашу щомісячну підтримку!",
  "invoiceThankYouBody": "Ваш рахунок уже в дорозі. Дякуємо за підтримку тварин!",
  "invoiceThankYouBodyCompany": "Ваш рахунок уже в дорозі. Дякуємо за підтримку тварин!",
  "giftedMembershipFlowTitle": "Подаруйте членство у Rädda Djuren-klubben",
  "stepChild": "Одержувач",
  "childDetailsTitle": "Хто стане членом?",
  "childFirstName": "Імʼя дитини",
  "childLastName": "Прізвище дитини",
  "childBirthDate": "Дата народження дитини",
  "childBirthDateHint": "Дитині має бути 13 років або менше",
  "childMustBeChild": "Дитині має бути 13 років або менше, щоб приєднатися до клубу.",
  "sameAddressAsMe": "Дитина живе за тією ж адресою, що і я",
  "agentMustBeAdult": "Вам має бути щонайменше 18 років, щоб подарувати членство.",
  "becomeChildMember": "Подарувати членство",
  "giftedMembershipThankYouTitle": "Дякуємо за ваш подарунок!",
  "giftedMembershipThankYouBody": "Членство у Rädda Djuren-klubben уже в дорозі. Дякуємо, що даєте дитині можливість допомагати тваринам.",
  "giftedMembershipPostalBody": "Ваш рахунок буде надіслано поштою. Дякуємо, що подарували членство!",
  "giftedAnnualStepRecipient": "Одержувач",
  "giftedAnnualStepGiftCard": "Подарунковий сертифікат",
  "giftedAnnualRecipientTitle": "Кому ви даруєте членство?",
  "giftedAnnualRecipientSsn": "Номер соціального страхування одержувача",
  "giftedAnnualRecipientLookupConfirm": "Ми знайшли дані одержувача:",
  "giftedAnnualRecipientSsnHint": "Наприклад 19940906-2388, використовується, щоб зареєструвати членство на потрібну особу і спробувати отримати її поштову адресу.",
  "giftedAnnualRecipientFirstName": "Імʼя одержувача",
  "giftedAnnualRecipientLastName": "Прізвище одержувача",
  "giftedAnnualRecipientBirthDate": "Дата народження одержувача",
  "giftedAnnualSameAddress": "Одержувач живе за тією ж адресою, що і я",
  "giftedAnnualCategoryTitle": "Яке членство отримає одержувач?",
  "giftedAnnualPresentTitle": "Який вітальний подарунок ви хочете подарувати?",
  "giftedAnnualGiftCardTitle": "Який подарунковий сертифікат ви хочете подарувати?",
  "giftedAnnualGiftCardSubtitle": "Подарунковий сертифікат надішлемо вам поштою.",
  "giftedAnnualBuyerTitle": "Хто ви, що даруєте членство?",
  "giftedAnnualSubmit": "Подарувати членство",
  "giftedAnnualThankYouTitle": "Дякуємо, що даруєте членство!",
  "giftedAnnualThankYouBody": "Разом ми змінюємо життя тварин на краще.",
  "giftedAnnualPostalBody": "Рахунок надішлемо вам поштою.",
  "giftedAnnualYouthBody": "Молодіжне членство зареєстровано.",
  "giftedAnnualAlreadyMember": "Одержувач вже є членом Djurens Rätt. Зверніться до служби підтримки донорів, якщо у вас є запитання.",
  "raiseAmountTitle": "Збільште щомісячний внесок",
  "raiseAmountIntro": "Як щомісячний донор Djurens Rätt ви можете легко збільшити свій щомісячний внесок.",
  "raiseAmountIdentifyTitle": "Ідентифікуйтеся",
  "raiseAmountIdentifyIntro": "Увійдіть за допомогою BankID, і ми знайдемо ваше членство.",
  "raiseAmountIdentifyCta": "Ідентифікуватися через BankID",
  "raiseAmountChooseTitle": "Виберіть нову щомісячну суму",
  "raiseAmountCurrent": "Ваша поточна сума: {amount} kr/міс",
  "raiseAmountSameError": "Це та сама сума, що й раніше. Виберіть іншу суму.",
  "raiseAmountMustBeHigher": "Ви вже даєте {current} {currency}/міс. Виберіть більшу суму, щоб збільшити.",
  "raiseAmountMustBeHigherUnknown": "Нова сума має бути більшою за поточну.",
  "raiseAmountUnavailable": "Не вдалося підтвердити, чи застосовано зміну. Спробуйте ще раз за хвилину — повторне надсилання тієї самої суми нічого не змінить, якщо її вже застосовано.",
  "raiseAmountNotFound": "Не вдалося знайти ваше членство. Перевірте дані та спробуйте ще раз.",
  "raiseAmountSubmit": "Підтвердити нову суму",
  "raiseAmountSuccessTitle": "Щомісячну суму змінено",
  "raiseAmountSuccessBody": "Ваш новий щомісячний внесок — {amount} kr/міс. Дякуємо за підтримку!",
  "raiseAmountAltToggle": "Identify yourself another way",
  "raiseAmountHelp": "Stuck? Email",
  "raiseAmountAltMemberNumberHint": "Your member number is in our letters and on the back of the Djurens Rätt magazine.",
  "raiseAmountAltMobileHint": "The number you have registered with us, e.g. +46xxxxxxxxx.",
  "raiseAmountAltCodeHint": "The six-digit code in the text message.",
  "raiseAmountAltEmailHint": "The address you have registered with us.",
  "raiseAmountAltSsnHint": "For example 19940906-2388, used to confirm it is you.",
  "raiseAmountAltInvalidCode": "The code is six digits.",
  "raiseAmountAltTabSms": "Text code",
  "raiseAmountAltTabEmail": "Email link",
  "raiseAmountAltTabMember": "Member number",
  "raiseAmountAltMobileLabel": "Mobile number",
  "raiseAmountAltSmsCta": "Send code",
  "raiseAmountAltSmsSent": "If we have {mobile}, we have sent a code to it. The code is valid for 10 minutes.",
  "raiseAmountAltCodeLabel": "Code",
  "raiseAmountAltCodeCta": "Sign in",
  "raiseAmountAltWrongCode": "The code is not right. Check it and try again.",
  "raiseAmountAltCodeExpired": "The code has expired. Ask for a new one.",
  "raiseAmountAltEmailLabel": "Email address",
  "raiseAmountAltEmailCta": "Send link",
  "raiseAmountAltEmailSent": "If we have {email}, we have sent a link to it. The link is valid for 30 minutes.",
  "raiseAmountAltLinkExpired": "The link has expired. Sign in again below.",
  "raiseAmountSignedInAs": "Signed in as {name}",
  "raiseAmountNotYou": "Not you?",
  "raiseAmountAltMemberNumberLabel": "Membership number",
  "raiseAmountAltSsnLabel": "Personal identity number",
  "raiseAmountAltMemberCta": "Sign in",
  "raiseAmountAltMemberNoMatch": "The membership number and personal identity number do not match. Check them and try again.",
  "raiseAmountAltRateLimited": "You have tried too many times. Wait a while and try again.",
  "raiseAmountAltChangeMobile": "Change number",
  "raiseAmountAltUnavailable": "We couldn't sign you in just now. Please try again in a moment.",
  "recommended": "Рекомендовано",
  "surveyBack": "Назад",
  "surveyBlixtCta": "Підписатися на Blixtmail",
  "surveyBlixtSendsTo": "Blixtmail надходитиме на {email}.",
  "surveyBlixtTitle": "Стань Blixt — дій онлайн для тварин!",
  "surveyBlixtBody": "Як цифровий волонтер ви проводите швидкі онлайн-акції для тварин: невеликі завдання, що дають реальний результат. Завдання надходитимуть на вашу пошту, і ви також можете користуватися нашим BlixtApp, який постійно поповнюється активностями.",
  "surveyBlixtMoreLabel": "Що робить цифровий волонтер?",
  "surveyBlixtFact1": "Підписує петиції на захист тварин",
  "surveyBlixtFact2": "Надсилає блискавичні листи компаніям і посадовцям",
  "surveyBlixtFact3": "Поширює повідомлення в соціальних мережах",
  "surveyBlixtDone": "Дякуємо! Тепер ви Blixt.",
  "surveyBlixtOpenApp": "Відкрити BlixtApp",
  "surveyBlixtError": "Щось пішло не так. Спробуйте ще раз.",
  "surveyChannelEmail": "електронна пошта",
  "surveyQuestionBadge": "Питання {n}",
  "surveyAmountChip": "{amount} SEK",
  "surveyAmountGroupSwish": "Разова пожертва через Swish",
  "surveyAmountGroupMonthly": "Щомісячна пожертва",
  "surveyShareDecline": "Ні, дякую",
  "surveyShareVia": "через",
  "surveyShareLinkLabel": "Посилання, щоб поділитися",
  "surveyShareCopy": "Скопіювати посилання",
  "surveyShareCopied": "Посилання скопійовано",
  "opensInNewTab": "(відкривається в новій вкладці)",
  "petitionStepMessage": "Повідомлення",
  "petitionMessagePlaceholder": "Напишіть повідомлення (необов'язково)",
  "petitionMessageLabel": "Ваше повідомлення",
  "petitionNewsletterOptIn": "Так, я хочу отримувати розсилку",
  "petitionSubmit": "Підписати петицію",
  "petitionThankYouTitle": "Дякуємо за підпис!",
  "petitionThankYouBody": "Ваш підпис зареєстровано.",
  "petitionAlreadySigned": "Ви вже підписали.",
  "petitionErrorMessage": "Щось пішло не так. Будь ласка, спробуйте ще раз.",
  "loading": "Завантаження",
  "secondAskSigningAs": "Підписуєте як",
  "secondAskPetitionTitle": "Підпишіть петицію",
  "petitionMotivationLabel": "Розкажіть, чому ви підписуєте (необов'язково, показано тут на сторінці)",
  "petitionBlixtmailOptIn": "Так, я хочу отримувати Blixtmail раз на тиждень із порадами щодо дій для тварин.",
  "petitionProgressLabel": "{count} підписів – далі ми прагнемо до {goal}!",
  "secondAskAlreadySigned": "Ви вже підписали",
  "secondAskDonateWithSwish": "Swish {amount} {currency}",
  "secondAskDonateWithCard": "Сплатити {amount} {currency} карткою",
  "secondAskSwishTo": "Запит Swish надійде на {mobile}.",
  "secondAskSwishChange": "Змінити номер",
  "secondAskSwishWrongNumber": "Неправильний номер? Змінити",
  "secondAskPaymentCancelled": "Платіж скасовано. Спробуйте ще раз або змініть номер, якщо він був неправильний.",
  "secondAskBecomeMonthly": "Стати щомісячним донором на {amount} kr/міс",
  "secondAskRaiseTo": "Підвищити до {amount} kr/міс",
  "secondAskCurrentMonthly": "Ви зараз даєте {amount} kr/міс",
  "secondAskDonorAs": "Ви даєте як",
  "secondAskMembershipSuccess": "Ласкаво просимо як щомісячний донор!",
  "secondAskRaiseSuccess": "Вашу щомісячну суму оновлено",
  "secondAskDonationTitle": "Підтримайте тварин пожертвою",
  "secondAskMonthlyTitle": "Станьте щомісячним донором",
  "shopBuyNow": "Купити зараз",
  "shopSoldOut": "Розпродано",
  "shopViewInStore": "Переглянути в магазині",
  "shopVariant": "Варіант",
  "shopNoProducts": "Зараз немає товарів для показу.",
  "shopMemberPrice": "Ціна для членів",
  "bankidQrEnlargedTitle": "Відскануйте QR-код",
  "bankidQrEnlargedLabel": "Збільшений QR-код BankID",
  "bankidQrEnlargedHint": "Відкрийте застосунок BankID на телефоні та відскануйте код.",
  "bankidQrAlt": "QR-код для сканування застосунком BankID",
  "bankidEnlargeQr": "Збільшити QR-код",
  "bankidExtend": "Продовжити час",
  "bankidExpired": "Час вичерпано",
  "close": "Закрити",
  "actStepStart": "Інформація",
  "actStepAmount": "Благодійний внесок",
  "actStepDetails": "Особиста інформація",
  "actStepAddress": "Поштова адреса",
  "actStepPayment": "Варіанти оплати",
  "actAmountTitle": "Скільки ви хотіли б пожертвувати тваринам?",
  "actDetailsTitle": "Хто ви?",
  "actDetailsSubtitle": "Заповніть свої дані",
  "actAddressTitle": "Яка ваша поштова адреса?",
  "actAddressSubtitle": "Отримані дані",
  "actAddressSubtitleManual": "Заповніть свої дані",
  "actPaymentTitle": "Як би ви хотіли оплатити свій подарунок тваринам?",
  "actPaymentSubtitle": "Оберіть спосіб оплати",
  "actPaymentTitleSingle": "Усе готово",
  "actPaymentSubtitleSingle": "Давайте подаруємо цей подарунок тваринам",
  "actAmountEyebrow": "Мій подарунок тваринам",
  "actAmountEyebrowCompany": "Наш подарунок тваринам",
  "actAmountHint": "Виберіть суму для внеску",
  "actAmountOther": "Інша",
  "actAmountCustomLabel": "Виберіть, скільки ви хочете пожертвувати",
  "actAmountCustomLabelCompany": "Виберіть, скільки ви хочете пожертвувати",
  "actSingle": "Одноразова пожертва",
  "actMonthly": "Щомісячна пожертва",
  "actSsnPlaceholder": "ррррммдд-нннн",
  "actSsnHint": "Шведський номер соціального страхування (personnummer), yyyymmdd-nnnn",
  "actNoSsn": "У мене немає шведського номера соціального страхування",
  "actHasSsn": "У мене шведський номер соціального страхування",
  "actBirthDateHint": "Дата народження, yyyy-mm-dd",
  "actMobileHint": "Введіть номер мобільного телефону без тире та пробілів, наприклад +380xxxxxxxxxx",
  "actFillOther": "Заповнити інші дані",
  "actLookupName": "Ім'я",
  "actLookupChangeAddress": "Заповнити інші дані",
  "actLookupUseFetched": "Використати отримані дані",
  "actLookupBannerPending": "Отримуємо ваші дані …",
  "actLookupBannerFound": "Ваші дані отримано!",
  "actLookupBannerFailed": "Не вдалося знайти адресу!",
  "actPaySwish": "Swish",
  "actPaySwishDesc": "Швидко та просто, рекомендуємо!",
  "actPayCard": "Картка",
  "actPayCardDesc": "Списується безпосередньо з вашої картки",
  "actPayCardDescCompany": "Списується безпосередньо з вашої картки",
  "actPayPostal": "Рахунок",
  "actPayPostalDesc": "Отримайте рахунок поштою",
  "actPayBySwish": "Оплатити через Swish",
  "actPayByCard": "Оплатити карткою",
  "actPayByPostal": "Оплатити",
  "actReadMore": "Детальніше",
  "videoPlay": "Відтворити відео",
  "videoPause": "Призупинити відео",
  "completing": "Хвилинку …",
  "actConsentTitle": "Підпишіть дозвіл на автоплатіж",
  "actConsentSubtitle": "Оберіть, як підписати",
  "actConsentBankid": "BankID",
  "actConsentBankidDesc": "Швидко підпишіть через BankID",
  "actConsentPostal": "Паперовий бланк",
  "actConsentPostalDesc": "Отримайте бланк поштою",
  "actBankTitle": "Отримати банківський рахунок",
  "actBankTitleManual": "Введіть банківські дані",
  "actBankTitleFetched": "Ваші отримані банківські дані",
  "actBankSubtitle": "Автоплатіж працює не з усіма рахунками, тож уточніть у банку, чи підтримує його ваш",
  "actSignTitle": "Підпишіть через BankID",
  "actSignSubtitle": "Підписуючи, я погоджуюся з цими умовами",
  "actConsentOtherMethod": "Обрати інший спосіб підпису",
  "actMonthlyStepAmount": "Сума",
  "actMonthlyStepAddress": "Адреса",
  "actPerMonthSuffix": "/місяць",
  "actStepBank": "Банк",
  "actStepSign": "Підписати"
}
